import React, { useContext, useEffect, useState, useRef } from "react";
import {
    Drawer,
    Box,
    Button,
    TextField,
    Typography,
    Stack,
    Autocomplete,
    Grid,
    CircularProgress
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { createIssue, getAllTicketList, getIssueType, getPriorityLevels, getProjects,getCompanyNameList } from "../../helper/api/api.js";
import toast from "react-hot-toast";
import { AuthContext } from "../../helper/context/auth/authContext";
import { useNavigate } from "react-router-dom";


const ChatBoxHelpdesk = ({ setOpen, open, fetchData, onReturnHome, prefillDescription }) => {
    const MAX_FILE_SIZE = 50 * 1024 * 1024;
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const { user } = useContext(AuthContext);
    const initialFormData = {
        projectID: 2,
        issueTypeID: 1,
        priorityID: "",
        Description: "",
        IsActive: 1,
        company: user[0]?.OU || ""
    };
    const [formData, setFormData] = useState(initialFormData);
    const [issueTypes, setIssueTypes] = useState([]);
    const [priorityLevels, setPriorityLevels] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState("");
    const [attachmentPayload, setAttachmentPayload] = useState("");
    const [loading, setLoading] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    // Auto-fill description from chatbot when Raise Ticket is clicked
    useEffect(() => {
        if (open && prefillDescription) {
            setFormData((prev) => ({
                ...prev,
                Description: prefillDescription,
            }));
        }
    }, [open, prefillDescription]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    const handleFileSelect = (file) => {
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            setError("File size must be less than 50 MB");
            setSelectedFile(null);
            return;
        }

        setError("");
        setSelectedFile(file);
    };

    // Browse file
    const handleBrowse = () => {
        fileInputRef.current.click();
    };

    // Input change
    const handleInputChange = (e) => {
        handleFileSelect(e.target.files[0]);
    };

    // Drag & Drop
    const handleDrop = (e) => {
        e.preventDefault();
        handleFileSelect(e.dataTransfer.files[0]);
    };

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result;
                if (typeof result === "string") {
                    const base64 = result.split(",")[1] || "";
                    resolve(base64);
                } else {
                    resolve("");
                }
            };
            reader.onerror = (err) => reject(err);
            reader.readAsDataURL(file);
        });

    useEffect(() => {
        const params = {
            User: user?.[0]?.UserName,
            Role: user?.[0]?.Role,
            OU: user?.[0]?.OU,
        };
        getCompanyNameList(params)
            .then((res) => {
                setCompanyList(res?.data?.data);
            })
            .catch((e) => {
                console.log("e", e);
            });
        getIssueType()
            .then((res) => setIssueTypes(res?.data?.data))
            .catch((e) => console.log("Error IssueTypes:", e));
        getPriorityLevels()
            .then((res) => setPriorityLevels(res?.data?.data))
            .catch((e) => console.log("Error Priority Level:", e));
        getProjects()
            .then((res) => setProjects(res?.data?.data))
            .catch((e) => console.log("Error Projects Level:", e));
    }, [])

    const validateForm = () => {
        if (!formData.projectID) {
            toast.error("Project is required");
            return false;
        }

        if (!formData.issueTypeID) {
            toast.error("Issue Type is required");
            return false;
        }

        if (!formData.priorityID) {
            toast.error("Priority is required");
            return false;
        }

        if (!formData.Description || formData.Description.trim() === "") {
            toast.error("Description is required");
            return false;
        }

        return true;
    };


    const handleSubmit = async () => {
        if (!validateForm()) return;
        try {
            setLoading(true);
            const formDataPayload = new FormData();

            formDataPayload.append("ProjectID", formData.projectID);
            formDataPayload.append("IssueTypeID", formData.issueTypeID);
            formDataPayload.append("Summary", "");
            formDataPayload.append("Description", formData.Description || "");
            formDataPayload.append("ReporterID", 3);
            formDataPayload.append(
                "UpdatedDate",
                new Date().toISOString().split("T")[0]
            );
            formDataPayload.append("DueDate", "");
            formDataPayload.append("PriorityID", formData.priorityID);
            formDataPayload.append("EstimatedHours", "");
            formDataPayload.append("ActualHours", "");
            formDataPayload.append("WorkflowID", "");
            formDataPayload.append("IsActive", formData.IsActive);
            formDataPayload.append("ModuleID", "");
            formDataPayload.append("SubModuleID", "");
            formDataPayload.append("StatusID", 1);
            formDataPayload.append("User", user[0]?.UserName);
            formDataPayload.append("OU", user[0]?.OU);
            formDataPayload.append("Role", user[0]?.Role);  
            formDataPayload.append("Company", formData.company);
            if (selectedFile) {
                formDataPayload.append("Attachment", selectedFile);
            }
            
        
            await createIssue(formDataPayload);

            setFormData(initialFormData);
            setSelectedFile(null);
            setError("");

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }

            toast.success("Issue created successfully!");
            navigate("/helpDesk", { replace: true });
            navigate(0);
            // fetchData();
            setOpen(false); // ✅ CORRECT

        } catch (error) {
            console.error("Error creating issue:", error);
            toast.error("Failed to create issue");
        } finally {
            setLoading(false);
        }
    };


    const handleReset = () => {
        setFormData(prev => ({
            ...prev,
            Description: ""
        }));
        setOpen(false);
    };

    const handleCancel = () => {
        setSelectedFile(null);
        setError("");
        fileInputRef.current.value = "";
    };


    //   const handleUpload = () => {
    //     if (!selectedFile) return;
    //     const formData = new FormData();
    //     formData.append("file", selectedFile);
    //     console.log("Uploading file:", selectedFile);
    //     // Example API call
    //     // fetch("/api/upload", {
    //     //   method: "POST",
    //     //   body: formData,
    //     // });
    //   };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={handleReset}
            sx={{
                "& .MuiDrawer-paper": {
                    width: 420,                 // Chat window width
                    height: 600,                // Chat window height
                    borderRadius: "16px",       // Rounded corners like popup
                    position: "fixed",
                    right: 24,
                    bottom: 24,
                    top: "auto",
                    boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                },
            }}
        >
            {/* 🔵 Header */}
            <Box
                sx={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    p: 2,
                    fontWeight: 600,
                    fontSize: "16px",
                }}
            >
                Helpdesk Support
            </Box>

            {/* 🧾 Scrollable Form Area */}
            <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                <Stack spacing={2}>

                            <Autocomplete
                                fullWidth
                                size="small"
                                options={companyList}
                                getOptionLabel={(option) => option.CompanyName || ""}

                                isOptionEqualToValue={(option, value) =>
                                    option.OU === value.OU
                                }

                                value={
                                    companyList.find(
                                        (item) => String(item.OU) === String(formData.company)
                                    ) || null
                                }

                                disabled

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Company *"
                                        size="small"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                            sx: { fontWeight: "bold" }
                                        }}
                                    />
                                )}
                            />
               
                    <Autocomplete
                        options={projects}
                        getOptionLabel={(option) => option?.ProjectName || ""}
                        value={projects?.find((p) => p?.ProjectID === formData?.projectID) || null}
                        onChange={(e, value) =>
                            setFormData({ ...formData, projectID: value?.ProjectID || "" })
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Project" size="small" required />
                        )}
                        disabled
                    />

                    <Autocomplete
                        options={issueTypes}
                        getOptionLabel={(option) => option?.IssueType || ""}
                        value={issueTypes.find((i) => i.IssueTypeId === formData.issueTypeID) || null}
                        onChange={(e, value) =>
                            setFormData({ ...formData, issueTypeID: value?.IssueTypeId || "" })
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Issue Type" size="small" required />
                        )}
                        disabled
                    />

                    <Autocomplete
                        options={priorityLevels}
                        getOptionLabel={(option) => option?.priorityLevel || ""}
                        value={priorityLevels.find((p) => p.priorityId === formData.priorityID) || null}
                        onChange={(e, value) =>
                            setFormData({ ...formData, priorityID: value?.priorityId || "" })
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Priority" size="small" required />
                        )}
                        // disabled
                    />

                    <TextField
                        label="Describe your issue"
                        name="Description"
                        value={formData.Description}
                        onChange={handleChange}
                        multiline
                        minRows={4}
                        fullWidth
                        required
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "170px",
                                alignItems: "flex-start",
                            },
                            "& textarea": {
                                height: "100% !important",
                            }
                        }}
                    />

                    {/* Attachment Box */}
                    <Box
                        sx={{
                            border: "1px dashed #bbb",
                            borderRadius: 2,
                            p: 2,
                            textAlign: "center",
                            cursor: "pointer",
                        }}
                        onClick={handleBrowse}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}
                    >
                        <input
                            ref={fileInputRef}
                            type="file"
                            hidden
                            onChange={handleInputChange}
                        />
                        <Typography variant="body2">
                            Drop file or <span style={{ color: "#1976d2" }}>browse</span>
                        </Typography>

                        {selectedFile && (
                            <Typography variant="caption" color="success.main">
                                {selectedFile.name}
                            </Typography>
                        )}
                        {error && (
                            <Typography variant="caption" color="error">
                                {error}
                            </Typography>
                        )}
                    </Box>
                </Stack>
            </Box>

            {/* 🔘 Footer Buttons */}
            <Box
                sx={{
                    p: 2,
                    borderTop: "1px solid #eee",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                }}
            >
                <Button onClick={handleReset}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
                >
                    {loading ? "Submitting..." : "Submit"}
                </Button>
            </Box>
        </Drawer>
    );

};

export default ChatBoxHelpdesk;